import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Fancybox } from '../../../../../../../../shared/components/Fancybox';
import { formatDate } from '../../../../../../../../shared/functions/Functions';
import { CustomImageHandler } from '../../../../../../../../shared/components/CustomImageHandler';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../../../../../model/user/User';
import CardLayout from '../../../../../../../../shared/components/card/CardLayout';

export default function AudienceKpiScreenshots({ user }: { user: User }) {
    const { t } = useTranslation();

    return (
        <CardLayout>
            <Col xs={12}>
                <h6>{t('influencer.profile.audienceKPIScreenshots')}</h6>
                <Row>
                    {user?.userKpiScreenshots?.map((screenshot: any) => (
                        <Col md={2} key={screenshot?.id} className="my-1">
                            <Fancybox>
                                <div
                                    data-fancybox="gallery-feedItems"
                                    className="cursor-pointer w-100"
                                    data-src={screenshot?.path ?? '/icons/filePlaceholder.png'}
                                >
                                    <CustomImageHandler
                                        classes="highlighted-post"
                                        thumbnailPath={screenshot.thumbnail}
                                        placeholder={screenshot?.path ?? '/icons/filePlaceholder.png'}
                                        photoPath={screenshot?.path ?? '/icons/filePlaceholder.png'}
                                        altTag={screenshot?.originalName!}
                                    />
                                </div>
                            </Fancybox>
                            <div className="text-center text-primary">{formatDate(screenshot?.createdAt)}</div>
                        </Col>
                    ))}
                </Row>
            </Col>
        </CardLayout>
    );
}
